import { PrivateRoutes } from 'infrastructure/shared/components'
import { Route, Routes } from 'react-router-dom'
import ProcessModelContainer from './ProcessModelContainer'

const ProcessModelRoutes = () => {
  return (
    <Routes>
      <Route element={<PrivateRoutes />}>
        <Route
          path='new/:processModelUuid'
          element={<ProcessModelContainer />}
        />
      </Route>
    </Routes>
  )
}

export default ProcessModelRoutes
